import { render, staticRenderFns } from "./putGoodsPop.vue?vue&type=template&id=57c82fe8&scoped=true&"
import script from "./putGoodsPop.vue?vue&type=script&lang=ts&"
export * from "./putGoodsPop.vue?vue&type=script&lang=ts&"
import style0 from "./putGoodsPop.vue?vue&type=style&index=0&id=57c82fe8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c82fe8",
  null
  
)

export default component.exports